import { useTranslation } from "react-i18next";
import request from "project-config/services/request/request";
import { ValidateRule } from "project-config/constants/validate-rule";
import { useGlobalStore } from "@/store/GlobalStore";

export function useRules() {
  const { t } = useTranslation("profile");
  const { isSubAccount } = useGlobalStore();
  return {
    phone: [
      { required: true, message: "" },
      {
        validator: async (_: any, phone: string) => {
          if (!phone) {
            return Promise.reject(t("mobile_phone_number_cant_be_empty"));
          }
          if (!/^1\d{10}$/.test(phone)) {
            return Promise.reject(t("please_enter_legal_cell_phone_number"));
          }
          const { code } = await request.post(
            "/api/rendering/user/validate/phone",
            { phone, accountType: isSubAccount ? 2 : 1 }
          );
          if (code !== 200) {
            return Promise.reject(
              new Error(t("mobile_phone_number_already_exists"))
            );
          }
          return Promise.resolve();
        },
      },
    ],
    email: [
      { required: true, message: t("mailbox_cannot_be_empty") },
      {
        validator: async (_: any, email: string) => {
          if (!email) return Promise.resolve(t("mailbox_cannot_be_empty"));

          if (!ValidateRule.EMAIL.test(email)) {
            return Promise.reject(t("email_rule"));
          }

          const { code } = await request.post(
            "/api/rendering/user/validate/email",
            {
              email: email.toLocaleString(),
              accountType: isSubAccount ? 2 : 1, // 1 主账号 2 子账号
            }
          );
          if (code !== 200) {
            return Promise.reject(t("mailbox_already_exists"));
          }
          return Promise.resolve();
        },
      },
    ],
  };
}
